if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        // The drawer wins when both exist (the "Item added" notice then acts as
        // a toast for catalog adds — see shouldUseToast()).
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && !this.shouldUseToast()) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // Catalog adds (product cards, quick-add modal) show the "Item added"
      // toast and keep the drawer closed, per window.cartAddBehavior
      // ('toast_catalog' | 'toast_always' | 'drawer').
      shouldUseToast() {
        this.toast = document.querySelector('cart-notification[data-mode="toast"]');
        const drawer = document.querySelector('cart-drawer');
        if (!this.toast || !drawer) return false;
        const behavior = window.cartAddBehavior || 'drawer';
        if (behavior === 'toast_always') return true;
        if (behavior !== 'toast_catalog') return false;
        return !!this.closest('quick-add-modal, .product-card-wrapper');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        // Toast instead of opening the drawer? Re-checked per add (the form may
        // sit inside a quick-add modal that was injected after construction).
        this.useToast = this.shouldUseToast();
        if (this.cart) {
          const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
          if (this.useToast) this.toast.getSectionsToRender().forEach((section) => sectionIds.push(section.id));
          formData.append('sections', [...new Set(sectionIds)]);
          formData.append('sections_url', window.location.pathname);
          // The submit button, not document.activeElement: Safari doesn't focus
          // clicked buttons, and the drawer returns focus here on close.
          this.cart.setActiveElement(this.submitButton || document.activeElement);
          if (this.useToast) this.submitButton.removeAttribute('aria-haspopup');
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            // Toast: keep the drawer closed but current (regions + count), and
            // show the "Item added" notice instead.
            const showResult = this.useToast
              ? () => {
                  if (this.cart.constructor.renderRegions) this.cart.constructor.renderRegions(response.sections);
                  this.cart.classList.remove('is-empty');
                  // The add response carries the line's TOTAL quantity; the toast
                  // should say how many were just added.
                  response.itemsAdded = parseInt(formData.get('quantity'), 10) || 1;
                  this.toast.renderContents(response);
                }
              : () => this.cart.renderContents(response);
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(showResult);
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              showResult();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
